import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnpin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.21767 2.295C2.04282 2.26549 1.85771 2.33013 1.74057 2.47947L1.30856 3.03027C1.13814 3.24755 1.17613 3.56184 1.39341 3.73226L6.62824 7.83812L6.56725 8.63125C5.4208 9.25312 4.51489 10.2937 4.0838 11.5906L4.05256 11.6844C3.94947 11.9875 3.99945 12.3219 4.19001 12.5844C4.38056 12.8469 4.68045 13 5.00221 13H13.2094L17.1303 16.0753C17.3476 16.2457 17.6619 16.2077 17.8323 15.9904L18.2643 15.4396C18.4347 15.2224 18.3968 14.9081 18.1795 14.7376L17.6532 14.3249C17.5737 14.3115 17.4963 14.2786 17.4283 14.2253L2.21767 2.295ZM14.4334 9.33443C14.2659 9.18488 14.0891 9.04625 13.9042 8.91935L14.4334 9.33443ZM13.4268 8.54495L13.0773 4H13.9989C14.5518 4 14.9985 3.55313 14.9985 3C14.9985 2.44687 14.5518 2 13.9989 2H6.00184C5.76162 2 5.54145 2.08435 5.36925 2.22511L13.4268 8.54495ZM9.00073 14H11V17C11 17.5531 10.5533 18 10.0004 18C9.44744 18 9.00073 17.5531 9.00073 17V14Z",
		fill: "#0D2976"
	})
});
export default SvgUnpin;
